import Joi from '@hapi/joi'

export const SupplierListingSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Company").messages({
        "any.invalid": `Select Company`,
        "any.required": `Company required`
    }),
    registrationNumber: Joi.string().max(100).required().messages({
        "string.pattern.base": `Please enter valid Employee Code`,
        "string.max": `Please enter {#limit} characters.`
    }),                                                        
    NIC: Joi.string().max(100).required().label("NIC").messages({
        "string.empty": `Please enter valid NIC`,
        "string.pattern.base": `Please enter valid NIC`,
        "string.max": `Please enter {#limit} characters.`
    }),
}

export const SupplierSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Select Company`,
        "any.required": `Company required`
    }),
    collectionPointID: Joi.number().invalid(0).required().label("Collectionpoint").messages({
        "any.invalid": `Select Collectionpoint.`,
        "any.required": `Collectionpoint required`
    }),    
    supplierCode:  Joi.string().required().invalid("0").label("Supplier Code").messages({
        "string.empty": `Supplier Code required`,
        "string.pattern.base": `Supplier Code cannot have invalid characters`,
        "any.invalid": `Cannot have 0 as supplier code`
    }),
    title: Joi.number().allow("", null,0).label("Title").messages({
        "string.empty": `Title required`,
        "string.pattern.base": `Please enter valid Title`,
        "string.max": `Please enter {#limit} characters.`
    }),
    firstName: Joi.string().max(100).required().label("First Name").messages({
        "string.empty": `First Name required`,
        "string.pattern.base": `Please enter valid First Name`,
        "string.max": `Please enter {#limit} characters.`
    }),
    secondName: Joi.string().max(100).allow("", null).label("Second Name").messages({
        "string.pattern.base": `Please enter valid Second Name`,
        "string.max": `Please enter {#limit} characters.`,
    }),
    lastName: Joi.string().max(100).allow("", null).label("Last Name").messages({
        "string.pattern.base": `Please enter valid Last Name`,
        "string.max": `Please enter {#limit} characters.`
    }),
    address1:  Joi.string().max(100).allow("", null).label("Address1").messages({
        "string.pattern.base": `Please enter valid Address`,
        "string.max": `Please enter {#limit} characters.`
    }),
    address2:  Joi.string().max(100).allow("", null).label("Address2").messages({
        "string.pattern.base": `Please enter valid Address`,
        "string.max": `Please enter {#limit} characters.`
    }),
    address3:  Joi.string().max(100).allow("", null).label("Address3").messages({
        "string.pattern.base": `Please enter valid Address`,
        "string.max": `Please enter {#limit} characters.`
    }),
    gender: Joi.string().alphanum().max(50).allow("", null).label("Gender").messages({
        "string.empty": `Gender required`,
        "string.pattern.base": `Please enter valid Gender`,
        "string.max": `Please enter {#limit} characters.`
    }),
    city: Joi.string().max(50).allow("", null).label("City").messages({
        "string.pattern.base": `Please enter valid City`,
        "string.max": `Please enter {#limit} characters.`
    }),
    countryCode: Joi.string().alphanum().allow("", null).max(50).label("Country").messages({
        "string.pattern.base": `Please enter valid Country`,
        "string.max": `Please enter {#limit} characters.`
    }),
    homePhoneNo: Joi.number().allow("", null).label("Home Phone Number").messages({
        "string.pattern.base": `Please enter valid Home Phone Number`,
        "string.max": `Please enter {#limit} characters.`
    }),
    officePhoneNo: Joi.number().allow("", null).label("Office Phone Number").messages({
        "string.pattern.base": `Please enter valid Home Office Number`,
        "string.max": `Please enter {#limit} characters.`
    }),
    dateOfBirth: Joi.string().isoDate().required().label("Date of birth"),
    mobileNo: Joi.number().allow("", null).label("Mobile Number").messages({
        "string.pattern.base": `Please enter valid Mobile Number`,
        "string.max": `Please enter {#limit} characters.`
    }),
    email:  Joi.string().allow("", null).label("Email").regex(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/).messages({
        "string.pattern.base": `"Invalid Email`,
    }),
    question: Joi.string().max(25).allow("", null).label("Question").messages({
        "string.pattern.base": `Please enter valid Question`,
        "string.max": `Please enter {#limit} characters.`
    }),
    answer: Joi.string().max(25).allow("", null).label("Answer").messages({
        "string.pattern.base": `Please enter valid Answer`,
        "string.max": `Please enter {#limit} characters.`
    }),
    registrationNumber: Joi.string().max(100).required().label("Registration Number").messages({
        "string.empty": `Registration Number required`,
        "string.pattern.base": `Please enter valid Registration Number`,
        "string.max": `Please enter {#limit} characters.`
    }),
    nameToBePrinted: Joi.string().max(100).required().label("Name To Be Printed").messages({
        "string.empty": `Name To Be Printed required`,
        "string.pattern.base": `Please enter valid Name To Be Printed`,
        "string.max": `Please enter {#limit} characters.`
    }),
    collectionTypeID:Joi.number().required().label("Product").messages({
        "any.invalid": `Select Product Name.`,
        "any.required": `Product name required`
    }),
    nic: Joi.string().max(50).required().label("NIC").messages({
        "string.empty": `NIC required`,
        "string.pattern.base": `Please enter valid NIC`,
        "string.max": `Please enter {#limit} characters.`
    }),
}